var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-string-create',{attrs:{"client-id":_vm.clientId,"back-route":{ name: 'client-content-strings', params: { clientId: _vm.clientId } }}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/content/strings/create.vue?vue&type=template&id=b8234e3e
// module id = wKO8
// module chunks = 0